import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CompletedPollAnswer, CompletedTriviaAnswer, GroupType, IAnswer, ProcessedPredictorAnswer } from '@fgb/core';

@Component({
  selector: 'fgbcl-answer-type-dropdown',
  templateUrl: './answer-type-dropdown.component.html',
  styleUrl: './answer-type-dropdown.component.scss',
})
export class AnswerTypeDropdownComponent implements OnInit {
  @Input() answers: IAnswer[] = [];
  @Input() groupType: GroupType;
  selectedAnswerId: number = 0;
  groupTypes = GroupType;
  @Input() isExternal: boolean = false;

  @Output() answerSelected = new EventEmitter<any>();

  ngOnInit(): void {
    let selectedAnswer = this.answers
      .map((answer) => answer as ProcessedPredictorAnswer | CompletedTriviaAnswer | CompletedPollAnswer)
      .find((answer) => answer.UserSelected);

    if (selectedAnswer) {
      this.selectedAnswerId = selectedAnswer.Id;
    }
  }

  onAnswerSelected() {
    this.answerSelected.emit({ answerId: this.selectedAnswerId, customerValue: this.selectedAnswerId });
  }
}
